import { lightChrome as chrome } from './chrome';

const breakpoints = {
  xs: '400px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
};

const mediaQueries = {
  xs: `@media (max-width: ${breakpoints.xs})`,
  sm: `@media (max-width: ${breakpoints.sm})`,
  md: `@media (max-width: ${breakpoints.md})`,
  lg: `@media (max-width: ${breakpoints.lg})`,
  xl: `@media (max-width: ${breakpoints.xl})`,
  gtSm: `@media (min-width: ${parseInt(breakpoints.sm) + 1}px)`,
};

const theme = {
  ...mediaQueries,
  primary: chrome.header,
  secondary:'#dc601e',
  button:'#dc601e',
  hightlightedBar:'#dc601e',
  sideBar: chrome.header,
  lightWhite:'#FFFFFF99',
  primaryDark: '#0D2349',
  primaryLight: '#9EA7B626',
  secondaryLight: '#9EA7B61A',
  secondaryLight2: '#FDF0E7',
  babyPink:'#FFC1F6',
  primaryLight2: '#8691a4',
  bgPebbleLight:'#dcdcdd9f',
  bgPebble:'#dcdcdd',
  darktext:'#121212',
  iconBg:'#367ECA26',
  readyBlue:'#367ECA',
  primaryLight4: '#774B78',
  primaryText: '#0d2349',
  lightYellowAutomation: '#FDF4ED',
  primaryLight3: '#001F5C1f',
  water: '#F0F4FA',
  fantasy: '#FDF4ED',
  primaryDisabled: '#EDEDED',
  lightBlack:' #0A0509',
  lightSlam:'#c3a2be',
  headingColor: '#0A0509',
  body: '#000000',
  textColor: '#585558',
  lightGray: '#FCFCFC', 
  smokegray:'#f1f1f1',
  iconGray: '#A4A2A4',
  lightHover: '#FAFAFA',
  inputDisabled: '#707070',
  lightBoldBlack: '#767476',
  purple:'#cdc2ea',
  newPink:'#dc601e',
  skyblue: "#EFF4FA",
  ashwhite: '#171717',
  thunder: "#292D32",
  inputBorder: '#EBEAEB',
  bodyBg: '#F4F7F9',
  white: '#fff',
  WhiteLinen: '#E7EFDC',
  lightbrown: "#F0E9D9",
  finch: '#5B6251',
  berylGreen: '#D8E6C6',
  inputPlaceHolder: '#6F767E', 
  subText: '#1D1D1DCC',
  lightText: '#1D1D1D99',
  successColorSky: '#00796B',
  inputColor: '#787377',
  defaultImage: '#8C0020',
  danger: '#B80000',
  skygreen: '#E0F2F1',
  success: '#6EAA64',
  lightGreen: '#c1e8eb33',
  tuna: '#33383F',
  orange: '#DBA745',
  blue: '#001F5C',
  gold: '#996B00',
  occyLogo: '#EC008C',
  successLight: '#ECF5EA',
  tagLightBlue: '#EDF1FC',
  tagBlueColor: '#6D93C9',
  tagLightgray: '#A4ADA3',
  tagLightYellow: '#FCF1E9',
  statusTextColor: '#343840',
  statusTagNew : '#F8F2F7', 
  statusTagNotSent:'#F5F5F5',
  statusTagOverDue: '#FFEFEF',
  statusTagCompleted: '#E0F2E0',
  statusTagSent: '#FCF7E5',
  statusTagPending: '#001F5C1f',
  statusTagAwaiting: '#FFF6DA',
  statusAwaitingColor: '#664700',
  lightPinkish: '#F5EAF3',
  TagCompletedBg :'#E0F2F1',
  chartBorderColor:'#E5E5E5',
  notesColorSent: '#BFAB61',
  notesColorOverDue: '#AF6060',
  notesColorCompleted: '#6F876F',
  lightGreenNew: '#E6F4F4',
  crystal: '#B2D3D6',
  noteTags: '#C2D3EB80',
  borderColor: '#767476',
  borderLight: '#E0E0E0',
  cornSilk: '#FFF9E5',
  bgPink: '#F9F5F6',
  darkGray: '#E6E5E6',
  eventColor1: '#F4DDE5',
  eventColor2: '#DADAF3',
  eventColor3: '#F4E5DE',
  eventColor4: '#ECEEEF',
  eventColor5: '#DCEAF5',
  interviewAttend: '#E3F1FF',
  blueIcon: '#204B8C',
  formSettingCardDesc: '#6F767E',
  textMuted: '#6F767E',
  hintBg: '#3B393C',
  green: '#00595C',
  lightYellow: '#FFF6DA',
  dullVoilet:'#73308A',
  chartFilled: '#A5A5E9',
  chartVacant: '#F7CEB5',
  LavenderColor: '#E0F3F5',
  NCSColor: '#E0E9F5',
  LineChartBorder: "#775078",
  ChartDashes: "#ABADB5",
  eventGreen: '#00796B',
  pyramidInterviewed: '#8D6587',
  pyramidOffered: '#521753',
  triggerIconColor: '#775078',
  chartManual: '#DC89A6',
  doughGraphtooltipTitle: '#C9C9C9',
  tootipBg: '#1B1D21',
  doughplaceholderColor: '#d2dee2',
  lineGraphBorderColor: '#8F8FF0',
  lightBgPink: "#FDFDFD",
  funnelIndex1: '#b68fb0',
  funnelIndex3: '#73486d',
  funnelIndex4: '#5e2f5e',
  graphPrimary: '#0d2349',
  graphOrange: '#D97109',
  teamLabelbg: 'rgba(194, 211, 235, 0.2)',
  scheduleSelfSlotInfoColor: 'rgba(255, 246, 218, 0.3)',
  greenBarylLightColor: 'rgba(216, 230, 198, 0.4)',
  smokeLightGray: 'rgba(158, 167, 182, 0.10)',
  orangeProcessingColor: 'rgba(219,167,69, 0.4)',
  dangerFailColor: 'rgba(255,0,0,0.4)',
  selfGrey: 'rgba(252, 241, 233, 0.2)',
  interviewtimebg: '#FAF7FA',
  interviewsuccess: '#26A69A',
  lightBrown: '#FCEDE3',
  darkBrown: '#C67E4F',
  stageIconColor: '#76747680',
  stagesDarkColor: '#313F62',
  DotColor: '#996b004d',
  darkRed: '#8F0000',
  creditBg1: '#dbf8ff',
  creditBg2: '#dedbff ',
  neutral: '#1A1D1F',
  InterviewFormikToolbarBg: '#FAFAFB',
  camelColor: '#FFAE1A',
  evaluationBannerColor: '#FFEBEE',
  previewColor: '#FFFAEB',
  previewColorBorder: '#FFE3AD',
  sourceColor: '#0080D0',
  screenColor: '#F9D28C',
  selectColor: '#C39CBD',
  offerColor: '#BBD49A',
  hireColor: '#34A023',
  StageHr: "#EFEFEF",
  seaPink: '#48a9a6',
  cyan: '#85C8DD',
  cyanBlue: '#B3CBED',
  palePeach: '#FFE2AC',
  blueDark: 'rgba(0, 31, 92, 1)',
  bodyColor: '#535870',
  lightBlue: '#f6f8fc',
  darkYellow: '#664700',
  cerebellumGrey: "#CDCBCD",
  verticalBarLineColor: '#585558',
  lightSeaGreen:'#1B9AAA',
  SlateBlue:'#5E4DB2',
  subscriptionBorderColor:'#ede8ed',
  lowCreditLoaderColor:'#ff3d00',
  scroll: '#c8c8c8',
  lightOrange:'#FFE3CF',
  lightRed:'#FED9DF',
  darkDoubleRed:'#C00',
  tagBlueBgColor:'#C2D3EB',
  skeltonBaseColor: '#e0e0e0',
  skeltonHighlightColor :'#f5f5f5',
  toastErrorBg: '#f1dbdbff',
  toastErrorBorderColor: '#B80000',
  toastErrorIconColor:'#B80000',
  toastErrorTextColor: '#585558',
  toastSuccessBg: '#ecf5ea',
  toastSuccessBorderColor: '#6eaa64',
  toastSuccessIconColor: '#6eaa64',
  selectBg: '#fff',
  actionsIconColor: chrome.header,
  tableHeaderBg: chrome.header,
  LineGraphTextColor: '#6e6e6e',
  LineGraphBorderColor: '#EBEAEB',
  calendarExternalEventBorder : '#C7932E',
  FormBasicControlGreen : '#e6efda',
  fadeOrange:'#f59e0b1a',

  // ---------------------------------------------------------------------
  // Design system tokens (UI/UX revamp - additive, do not remove/rename
  // existing keys above; new components should prefer these tokens).
  // ---------------------------------------------------------------------

  // Radius scale
  radiusXs: '4px',
  radiusSm: '8px',
  radiusMd: '12px',
  radiusLg: '16px',
  radiusXl: '20px',
  radiusPill: '999px',

  // Spacing scale (4px base grid)
  space1: '4px',
  space2: '8px',
  space3: '12px',
  space4: '16px',
  space5: '20px',
  space6: '24px',
  space7: '32px',
  space8: '40px',

  // Typography scale
  fontSizeXs: '11px',
  fontSizeSm: '12px',
  fontSizeBase: '14px',
  fontSizeMd: '16px',
  fontSizeLg: '18px',
  fontSizeXl: '20px',
  fontSize2xl: '24px',
  fontSize3xl: '32px',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,

  // Elevation / shadow scale (soft, navy-tinted)
  shadowSm: '0 1px 2px rgba(13, 35, 73, 0.06)',
  shadowMd: '0 4px 12px rgba(13, 35, 73, 0.08)',
  shadowLg: '0 12px 32px rgba(13, 35, 73, 0.12)',
  shadowCard: '0 2px 10px rgba(13, 35, 73, 0.06)',

  // Semantic chrome (header matches sidebar in light mode per design reference)
  headerBg: chrome.header,
  headerForeground: '#FFFFFFCC',
  headerAvatarBg: '#2FB3A0',
  onHeader: chrome.onHeader,
  workspaceBg: chrome.workspace,
  workspaceRgb: chrome.workspaceRgb,
  cardBg: chrome.card,
  radiusCard: chrome.radiusCard,
  radiusModal: chrome.radiusModal,
  dropZoneBg: chrome.dropZone,
  portletBg: chrome.card,
  modalBg: chrome.modal,
  modalHeaderBg: chrome.modalHeader,
  modalPanelBg: chrome.modalPanel,
  modalInnerBg: chrome.surface,

  // Semantic surface aliases (map onto existing raw colors)
  surface: chrome.surface,
  surfaceSubtle: chrome.surfaceSubtle,
  surfaceHover: '#FAFAFA',
  borderSubtle: '#EBEAEB',
  textPrimary: '#0A0509',
  textSecondary: '#585558',
  tableText: '#0A0509',
  paginationActiveBg: chrome.header,
  paginationActiveColor: chrome.onHeader,
  paginationMuted: '#767476',
  paginationBtnBg: chrome.card,
  paginationBtnBorder: '#dcdcdd',
  paginationBtnColor: chrome.header,

  // Secondary section nav (settings column): grey panel, white item cards,
  // navy fill on the active row
  navPanelBg: chrome.surfaceSubtle,
  navItemBg: chrome.card,
  navItemText: 'rgba(13, 35, 73, 0.72)',
  navItemShadow: '0 1px 3px rgba(13, 35, 73, 0.10)',
  navItemHoverBg: '#FFFFFF',
  navItemActiveBg: chrome.header,
  navItemActiveText: chrome.onHeader,
  navSectionText: chrome.header,

  // Detail "label block + value" rows (candidate overview, application modal)
  fieldLabelBg: chrome.fieldLabel,
  fieldLabelText: chrome.onHeader,
  fieldValueBg: chrome.surface,
  fieldRowBg: chrome.surface,
  fieldActionLabelBg: chrome.header,
  fieldActionRowBg: chrome.card,
  // Rows are separated by their own drop shadow, so no hairline border on light
  fieldRowBorder: 'transparent',
  fieldRowShadow: '0 1px 4px rgba(13, 35, 73, 0.16)',

  // Solid identity pills in detail headers (job title / rating)
  tagTealBg: '#7EC3C0',
  tagTealText: '#0d2349',
  tagGoldBg: '#E0C086',
  tagGoldText: '#0d2349',

  // Recruiting pipeline / dashboard stat-card palette (reference design)
  pipelineAppliedBg: '#FBE4E8',
  pipelineAppliedText: '#8C2B44',
  pipelineScreenedBg: '#F3E3BE',
  pipelineScreenedText: '#7A5A16',
  pipelineInterviewBg: '#BFE6DC',
  pipelineInterviewText: '#1B5E4E',
  pipelineOfferBg: '#DCE3D4',
  pipelineOfferText: '#4A5A3C',
  pipelineHiredBg: '#CBDBEF',
  pipelineHiredText: '#1F3B66',
};

export default theme;
